import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const SCHEMA_VERSION = 1;
const MAX_ITEMS = 4;

export interface ComparatorItem {
  yachtId: string;
  model: string;
  imageUrl: string;
  price: number;
  dateFrom: string;
  dateTo: string;
}

interface ComparatorState {
  version: number;
  items: ComparatorItem[];
}

const initialState: ComparatorState = {
  version: SCHEMA_VERSION,
  items: [],
};

const comparatorSlice = createSlice({
  name: "comparator",
  initialState,
  reducers: {
    addToComparator(state, action: PayloadAction<ComparatorItem>) {
      if (state.version !== SCHEMA_VERSION) {
        state.items = [];
        state.version = SCHEMA_VERSION;
      }
      const exists = state.items.some((i) => i.yachtId === action.payload.yachtId);
      if (!exists && state.items.length < MAX_ITEMS) {
        state.items.push(action.payload);
      }
    },
    removeFromComparator(state, action: PayloadAction<string>) {
      state.items = state.items.filter((i) => i.yachtId !== action.payload);
    },
    clearComparator(state) {
      state.items = [];
    },
  },
});

export const { addToComparator, removeFromComparator, clearComparator } = comparatorSlice.actions;
export default comparatorSlice.reducer;
